export default __webpack_public_path__ + "static/media/alertCircleRed.9e7ad1b0.svg";